<template>
  <div class="service-process">
    <div class="map-container" id="map-container"></div>
    <div class="process-wrapper">
      <div class="process-dl" ref="process"  v-for="(item,index) in assignUserList" :key="index">
        <div class="process-dt" @click="trigger(index)">
          <i class="icon-worker"></i>
          <span class="name">{{item.TrueName}}</span>
          <span class="grade">评分：{{item.EngineerGrade}}</span>
          <time class="time">{{item.LastProgressCreateTime}}</time>
          <span class="status">{{item.LastProgressContent}}</span>
          <div class="right-btns">
            <div class="btn-item" v-if="isShowChat" @click.stop="chat">
              <i class="icon-chat"></i>
              <div class="text">在线聊天</div>
            </div>
            <div class="btn-item" @click.stop="call(item)">
              <i class="icon-tel"></i>
              <div class="text">电话沟通</div>
            </div>
          </div>
        </div>
        <ul class="process-dd">
          <li :class="['status-item',{'on':status.ProgressStatus==0}]" v-for="(status,idx) in item.UserProgressList" :key="idx">
            <span class="status">【{{status.Content}}】</span>
            <div class="icon"></div>
            <div class="item-right">
              <span class="time">{{status.CreateTime}}</span>
              <span class="desc">{{status.Remark}}</span>
              <button class="btn-text" v-if="status.StepNum==9 || status.StepNum==19" @click="look(status.JobId,status.StepNum,status.Id)">查看</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <my-dialog class="confirm-dialog" :show="showArrive" title="到场确认" @close="showArrive=false" width="700px">
      <div class="inner" v-if="arriveData">
        <div class="label">确认服务信息</div>
        <table class="table">
          <tr>
            <th>领域</th>
            <th>服务类型</th>
            <th>产品/设备</th>
            <th>产品品牌</th>
            <th>产品系列</th>
            <th>数量</th>
          </tr>
          <tr v-for="(item,index) in arriveData.JobProductLineList" :key="index">
            <td>{{item.ProductCateAreaName}}</td>
            <td>{{item.ServiceStageName}}</td>
            <td>{{item.ProductCategoryName}}</td>
            <td>{{item.BrandName}}</td>
            <td>{{item.SeriesName}}</td>
            <td>{{item.DeviceCount}}</td>
          </tr>
        </table>
        <div class="label">现场自拍</div>
        <div class="img-box">
          <img v-for="(item,index) in arriveData.SceneEngineerImgList" :key="index" class="pic" :src="item.FileUrl" alt="">
        </div>
        <div class="label">现场照片</div>
        <div class="img-box">
          <template v-for="(item,index) in arriveData.SceneImgList">
            <a v-if="item.FileType==1" :key="index" :href="item.FileUrl">
              <img  class="pic" :src="item.IconUrl" alt="">
            </a>
            <img v-else :key="index" class="pic" :src="item.FileUrl" alt="">
          </template>
        </div>
      </div> 
    </my-dialog>
    <my-dialog class="confirm-dialog" :show="showLeave" title="确认服务" @close="showLeave=false" width="700px">
      <div class="inner" style="height:450px;overflow-y: auto;" v-if="leaveData"> 
        <div class="label" style="font-weight: 600; font-size: 16px; color: #333333;">服务日志</div>
        <table class="table">
          <tr>
            <th>工程师</th>
            <th>日期</th>
            <th>时间属性</th>
            <th>出发时间</th>
            <th>工作时间</th>
            <th>返程时间</th>
          </tr>
          <tr v-for="(item,index) in leaveData.WorkLogList" :key="index">
            <td>{{item.UserName}}</td>
            <td>{{item.WorkLogDate}}</td>
            <td>{{item.DateType}}</td>
            <td>{{item.GoTime}}</td>
            <td>{{item.WorkTime}}</td>
            <td>{{item.BackTime }}</td>
          </tr>
        </table>

      <!-- 离场服务确认 -->
       <template v-if="leaveData">
          <div v-for="(item,index) in leaveData.ModuleList" :key="index" >
              <div class="label" style="font-weight: 600; font-size: 16px; color: #333333;">{{item.ModuleName}}</div>
              <ul style="margin-bottom: 10px;margin-left: 10px;">
                <li v-for="(items,indexs) in item.SubsetList" :key="indexs">
                  <div style="font-size: 16px;color: #666;">{{items.SubsetName}}</div>
                  <div style="margin-left: 10px;" v-for="(itemss,indexss) in items.ServiceProblemList" :key="indexss">
                    <div style="font-size: 15px;color: #666;">{{itemss.Title}}</div>
                    <p style="font-size: 14px;color: #999;" v-for="(itemsss,indexsss) in itemss.ProblemOptionList" :key="indexsss">
                      <template v-if="itemss.ProblemType !=3">
                        <span v-if="itemsss.IsChecked">{{itemsss.Content}}</span>
                      </template>
                      <span v-else>{{itemsss.Content}}</span>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
        </template>

        <div class="label" style="font-weight: 600; font-size: 16px; color: #333333;margin-top: 10px;">服务后现场照片</div>
        <div class="img-box">
          <template v-for="(item,index) in leaveData.SceneImgList">
            <a v-if="item.FileType==1" :key="index" :href="item.FileUrl">
              <img  class="pic" :src="item.IconUrl" alt="">
            </a>
            <img v-else :key="index"   
              preview="7"
              :preview-text="item.FileName"
               class="pic" :src="item.FileUrl" alt="">
          </template>
        </div>

        <div class="label" style="font-weight: 600; font-size: 16px; color: #333333;">现场客户签字</div>
        <div class="img-box">
          <img v-for="(item,index) in leaveData.SignatureImgList" 
          :key="index" 
          preview="7"
          :preview-text="item.FileName"
          class="pic" :src="item.FileUrl" alt="">
        </div>
      </div>
    </my-dialog>
    <call-dialog :show="showCall" @close="showCall=false" :phone="contacts" :isLongTime="IsLongTime" :jobId="jobId"></call-dialog>
  </div>
</template>
<script>
let BMap=window.BMap;
let map,local;
import {GetServiceProcessView,GetConfirmJobTaskInfo,GetLeaveConfirmInfo,} from '@/scripts/api.js'
import myDialog from "@/components/gkDialog.vue";
import callDialog from '@/components/callDialog.vue'
export default {
  components:{
    myDialog,
    callDialog
  },
  data(){
    return{
      city:'湖州',
      icon:require('@/assets/createOrderProcess/map-worker.png'),
      iconActive:require('@/assets/createOrderProcess/map-worker-active.png'),
      iconTarget:require('@/assets/createOrderProcess/icon-target.png'),
      jobId:'',
      assignUserList:[],
      destination:null,
      showArrive:false,
      arriveData:null,
      showLeave:false,
      leaveData:null,
      chatId:'',
      phone: '',
      showCall:false,
      isLongTime:false,
      isShowChat:false,
    }
  },
  watch: {
    assignUserList(value){
      if(value.length){
        this.renderMap();
      }
    }
  },
  computed: {
    userInfo(){
      return this.$store.state.userInfo;
    }
  },
  created() {
    this.jobId = this.$route.query.jobId;
    this.phone = this.$store.state.userInfo.Handset;
    this.init();
  },
  mounted() {
    this.renderMap();
    this.isShowChat=this.$parent.baseInfo.IsShowChatOnline || false;
  },
  methods: {
    init(){
      GetServiceProcessView({
       JobId:this.jobId,
       platform:'pcweb' 
      }).then(r=>{
        if(r.Result==1){
          let list=r.Data.AssignUserList || [];
          for (let i = 0; i < list.length; i++) {
            list[i]['currentStatus']='';
            list[i]['statusTime']='';
            if(!list[i].UserProgressList){
              list[i].UserProgressList=[];
            }
          }
          this.chatId=r.Data.EasemobGroupId;
          this.destination=r.Data.Destination;
          this.assignUserList=list;
        }
      })
    },
    //渲染地图
    renderMap(){
      let that=this;
      map = new BMap.Map("map-container");
      //地图控制器
      let navigationControl = new BMap.NavigationControl({
          anchor: window.BMAP_ANCHOR_TOP_RIGHT, // 靠左上角位置
          type: window.BMAP_NAVIGATION_CONTROL_LARGE, // LARGE类型
          enableGeolocation: true, // 启用显示定位
      });
      // map.addControl(navigationControl)
      map.enableScrollWheelZoom(true);
      //地图中心为选中的城市或者用户所在城市
      // if(that.city){
      //   map.centerAndZoom(that.city, 10);
      // }else{
      //   let geolocation = new BMap.Geolocation();
      //   geolocation.enableSDKLocation();
      //   geolocation.getCurrentPosition(function(r) {
      //       if (this.getStatus() == window.BMAP_STATUS_SUCCESS) {
      //           map.centerAndZoom(r.point, 12);
      //       } else {
      //           alert('failed' + this.getStatus());
      //       }
      //   });
      //   return;
      // }
      this.$nextTick(()=>{
        that.setMarker();
      })
    },
    //添加标识
    setMarker(point){
      map.clearOverlays();  
      let that=this;
      let pointArray=[];
      for (let i = 0; i < that.assignUserList.length; i++) {
        pointArray[i] = new BMap.Point(that.assignUserList[i].Lng,that.assignUserList[i].Lat);
        let icon;
        if(point && point.lng==that.assignUserList[i].Lng && point.lat==that.assignUserList[i].Lat){
          icon=new BMap.Icon(that.iconActive,new BMap.Size(24,31));
        }else{
          icon=new BMap.Icon(that.icon,new BMap.Size(24,31));
        }
        let marker = new BMap.Marker(pointArray[i],{icon}); // 创建标注
        marker.setZIndex(2)
        map.addOverlay(marker);
        marker.addEventListener("click",that.pointTap);
      }
      if(that.destination){
        let targetPoint=new BMap.Point(that.destination.Lng,that.destination.Lat);
        let icons=new BMap.Icon(that.iconTarget,new BMap.Size(68,46));
        let markers = new BMap.Marker(targetPoint,{icon:icons}); // 创建标注
        markers.setZIndex(1)
        map.addOverlay(markers);
      }
      map.setViewport(pointArray);
    },
    //点击标识
    pointTap(e) {
      var point = e.target.getPosition();
      let index=-1;
      for (let i = 0; i < this.assignUserList.length; i++) {
        if(point.lng==this.assignUserList[i].Lng && point.lat==this.assignUserList[i].Lat){
          index=i;
        }
      }
      if(index>-1){
        this.trigger(index);
      }
    },
    //点击
    trigger(index){
      let height=this.$refs.process[index].querySelector('.process-dd').offsetHeight +30+80;
      for (let i = 0; i < this.assignUserList.length; i++) {
        if(i!==index){
          this.assignUserList[i].SelectStatus=false;
          this.$refs.process[i].style.height=100+'px';
        }
      }
      if(this.assignUserList[index].SelectStatus){
          this.$refs.process[index].style.height=100+'px';
        this.assignUserList[index].SelectStatus=false;
      }else{
        this.$refs.process[index].style.height=height+'px';
        this.assignUserList[index].SelectStatus=true;
      }
      let point={lng:this.assignUserList[index].Lng,lat:this.assignUserList[index].Lat};
      this.setMarker(point);
    },
    //去聊天
    chat(){
      this.$router.push({
        path:'/chat/chatContent',
        query:{
          activeKey:'group',
          chatId:this.chatId
        }
      })
    },
    //三方通话
    call(contacts){
      this.showCall = true;
      this.contacts = contacts.Handset;
      this.isLongTime = false;
      // if(!contacts){
      //     this.$toast('对方电话有误，请联系速派021-60956592！')
      //     return;
      // }
      // AXBindPhone({
      //     orgNumber:contacts,
      //     platform:'pcweb'
      // }).then(r=>{
      //     if(r.Result==1){
      //       this.$alert('您呼叫的电话号码为：'+r.Data.PrivateNumber);
      //     }else{
      //         this.$toast(r.Message);
      //     }
      // })
    },
    //查看
    look(jobId,process,id){
      if(process==9){
        GetConfirmJobTaskInfo({
          jobId:jobId,
          progressId:id,
          platform:'pcweb'
        }).then(r=>{
          if(r.Result==1){
            this.arriveData=r.Data;
            this.showArrive=true;
            this.$previewRefresh();
          }else{
            this.$toast(r.Message);
          }
        })
      }
      if(process==19){
        GetLeaveConfirmInfo({
          jobId:jobId,
          progressId:id,
          platform:'pcweb'
        }).then(r=>{
          if(r.Result==1){
            this.leaveData=r.Data;
            this.$previewRefresh();
            this.showLeave=true;
          }else{
            this.$toast(r.Message);
          }
        })
      }
    },
  },
}
</script>
<style scoped lang="scss">
.service-process{
  width: 840px;
  overflow: hidden;
  padding-top: 66px;
  .map-container{
    width: 840px;
    height: 360px;
    border-radius: 2px;
    background-color: #f8f8f8;
  }
  .process-wrapper{
    width: 760px;
    margin: -42px auto 100px;
  }
  .process-dl{
    margin-bottom: 20px;
    height: 100px;
    overflow: hidden;
    transition: all linear 0.3s;
  }
  .process-dt{
    position: relative;
    width: 760px;
    height: 80px;
    background: #F9F9F9;
    box-shadow: 1px 3px 5px 0px rgba(0, 0, 0, 0.13);
    opacity: 0.9;
    border-radius: 6px;
    overflow: hidden;
    padding: 12px 20px;
    margin-bottom: 30px;
    .icon-worker{
      width: 30px;
      height: 30px;
      display: inline-block;
      vertical-align: middle;
      background: url('~@/assets/createOrderProcess/icon-engineer.png') no-repeat center /contain;
    }
    .name{
      vertical-align: middle;
      font-size: 16px;
      color: #333;
      line-height: 56px;
      display: inline-block;
      margin-left: 10px;
    }
    .grade{
      vertical-align: middle;
      display: inline-block;
      margin-left: 12px;
      font-size: 14px;
      color: #999;
    }
    .time{
      vertical-align: middle;
      display: inline-block;
      margin-left: 60px;
      font-size: 14px;
      color: #999;
    }
    .status{
      vertical-align: middle;
      display: inline-block;
      margin-left: 40px;
      font-size: 16px;
      color: #333;
    }
    .right-btns{
      position: absolute;
      right: 0;
      top: 20px;
      z-index: 0;
    }
    .btn-item{
      float: left;
      margin-right: 30px;
      text-align: center;
      cursor: pointer;
      .icon-tel{
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url('~@/assets/createOrderProcess/icon-tel.png') no-repeat center;
        background-size: contain;
      }
      .icon-chat{
        width: 22px;
        height: 22px;
        display: inline-block;
        background: url('~@/assets/createOrderProcess/icon-chat.png') no-repeat center;
        background-size: contain;
      }
      .text{
        font-size: 14px;
        color: #666;
        line-height: 20px;
        padding-bottom: 2px;
      }
      &:hover{
        .text{
          color: #f75959;
          border-bottom: 1px solid #f75959;
        }
      }
    }
  }
  .process-dd{
    .status-item{
      position: relative;
      padding: 10px 40px 10px 180px;
      &:before{
        content: "";
        position: absolute;
        left: 134px;
        top: 0;
        height: 100%;
        width: 1px;
        background-color: #e5e5e5;
      }
      &.on{
        .status{
          color: #f75959;
        }
        .icon{
          width: 14px;
          height: 14px;
          top: 14px;
          left: 127px;
          background-color: #f75959;
        }
      }
    }
    .status{
      position: absolute;
      left: 0;
      width: 80px;
      white-space: nowrap;
      font-size: 16px;
      color: #333;
      font-weight: bold;
      line-height: 24px;
    }
    .icon{
      position: absolute;
      left: 129px;
      top: 17px;
      z-index: 2;
      width: 10px;
      height: 10px;
      background-color: #e5e5e5;
      transform: rotate(-45deg);
    }
    .item-right{
      overflow: hidden;
    }
    .btn-text{
      font-size: 14px;
      color: #f75959;
      line-height: 24px;
      position: absolute;
      right: 0;
      top: 10px;
      z-index: 2;
      background-color: #fff;
      cursor: pointer;
      &:active{
        color: #ff3838;
      }
    }
    .time{
      float: left;
      width: 140px;
      margin-right: 30px;
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
    .desc{
      float: left;
      width: 360px;
      font-size: 14px;
      color: #999;
      line-height: 24px;
      word-break: break-all;
    }
  }
  .confirm-dialog{
    .inner{
      .label{
        font-size: 16px;
        color: #333;
        line-height: 24px;
        margin-bottom: 10px;
      }
    }
    .table{
      border-collapse: collapse;
      border: 1px solid #e5e5e5;
      width: 100%;
      margin-bottom: 10px;
      tr{
        border-bottom: 1px solid #e5e5e5;
      }
      th{
        font-size: 14px;
        color: #999;
        background-color: #f9f9f9;
        line-height: 20px;
        padding: 12px 0;
        font-weight: normal;
      }
      td{
        font-size: 14px;
        line-height: 20px;
        color: #333;
        background-color: #fff;
        padding: 12px 0;
        text-align: center;
      }
    }
    .img-box{
      overflow: hidden;
      margin-bottom: 5px;
    }
    
    .img-box img{
      border: 1px solid #e5e5e5;
    }

    .pic{
      float: left;
      width: 80px;
      height: 80px;
      margin-right: 10px;
      margin-bottom: 10px;
    }
    .sign{
      display: block;
      width: 200px;
      height: 80px;
    }
  }
}
.call-inner{
        padding: 20px 20px 0;
    }
    .form-item{
        position: relative;
        margin-bottom: 20px;
        width: 100%;
        padding-left: 100px;
        .label{
            width: 100px;
            line-height: 40px;
            font-size: 14px;
            color: #333;
            position: absolute;
            left: 0;
            top: 0;
        }
        .input-box{
            width: 100%;
            position: relative;
            height: 40px;
            padding-right: 100px;
        }
        .input{
            width: 100%;
            height: 40px;
            padding: 8px 10px;
            font-size: 14px;
            color: #333;
            line-height: 22px;
            border: 1px solid #e5e5e5;
        }
        .btn-call{
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2;
            width: 100px;
            height: 40px;
            font-size: 14px;
            color: #fff;
            text-align: center;
            line-height: 40px;
            background-color: #f75959;
            cursor: pointer;
        }
    }
</style>